import { useNavigate } from 'react-router'
import { useTrackerHref } from './useTrackerHref'

export type TrackerNavigate = (to: string) => void

/**
 * The ONE imperative navigation seam for the package (spec §6, §15 invariant 2).
 * Feature code never imports react-router's useNavigate directly — it calls this.
 * Resolves the target against the tracker's mount-point basename (via
 * useTrackerHref) so navigation stays within /tracker when embedded and at root
 * in the free SPA. A future non-react-router shell replaces only this module.
 */
export function useTrackerNavigate(): TrackerNavigate {
  const navigate = useNavigate()
  const href = useTrackerHref()

  return (to: string) => navigate(href(to))
}
